import { queries } from "../../shared/queries";
import { useQuery } from "./useQuery";

// `undefined` means the flags query hasn’t completed yet, so the flag’s state
// is unknown. Truthy checks treat it as off; callers that make irreversible
// decisions (like redirecting away from a flag-gated route) should wait for a
// definite boolean.
export function useFeatureFlag(name: string): boolean | undefined {
  const [flags, result] = useQuery(queries.featureFlags());
  if (flags.some((f) => f.name === name)) return true;
  return result?.type === "complete" ? false : undefined;
}
